<template>
    <b-badge :variant="variant">
        {{ label }}
    </b-badge>
</template>

<script>
import {BBadge} from 'bootstrap-vue'

const VARIANTS = {
    draft: 'warning',
    active: 'success',
    outdated: 'secondary',
}

export default {
    components: {BBadge},
    props: {
        status: {
            type: String,
            default: '',
        },
    },
    computed: {
        variant() {
            return VARIANTS[this.status] || 'light-primary'
        },
        label() {
            if (!this.status) {
                return 'New'
            }

            return this.status.charAt(0).toUpperCase() + this.status.slice(1)
        },
    },
}
</script>
